"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-non-null-assertion */
// @ts-nocheck
const format_1 = require("ol/format");
const Map_js_1 = __importDefault(require("ol/Map.js"));
const jszip_1 = __importDefault(require("jszip"));
const Vector_js_1 = __importDefault(require("ol/layer/Vector.js"));
const emptyConfig = {
    projection: { dataProjection: '', featureProjection: '' },
    parcelName: '',
    pointLayer: new Vector_js_1.default(),
    polygonLayer: new Vector_js_1.default(),
    map: new Map_js_1.default(),
};
class Download {
    constructor(config = emptyConfig) {
        this.projection = config.projection || {
            dataProjection: '',
            featureProjection: '',
        };
        this.pointLayer = config.pointLayer || new Vector_js_1.default();
        this.polygonLayer = config.polygonLayer || new Vector_js_1.default();
        this.map = config.map || new Map_js_1.default();
        this.parcelName = config.parcelName || '';
    }
    download(typeFile) {
        if (typeFile === '.png') {
            this.downloadPNG();
        }
        else if (typeFile === '.kml') {
            this.downloadKML();
        }
        else if (typeFile === '.kmz') {
            this.downloadKMZ();
        }
        else if (typeFile === '.geojson') {
            this.downloadJSON();
        }
    }
    get mapFeatures() {
        const pointSource = this.pointLayer.getSource();
        const polygonSource = this.pointLayer.getSource();
        const pointFeatures = pointSource.getFeatures();
        const polygonFeatures = polygonSource.getFeatures();
        const allFeatures = pointFeatures.concat(polygonFeatures);
        return allFeatures;
    }
    downloadPNG() {
        this.map.getRenderer();
        const mapElement = this.map.getTargetElement();
        const canvasElement = mapElement.querySelector('canvas');
        const dataURL = canvasElement.toDataURL('image/png');
        const link = document.createElement('a');
        link.href = dataURL;
        link.download = `${this.parcelName}.png`;
        link.click();
    }
    downloadKML() {
        const text = new format_1.KML().writeFeatures(this.mapFeatures, {
            featureProjection: this.projection.featureProjection,
            dataProjection: this.projection.dataProjection,
        });
        this.downloadFile(text, `${this.parcelName}.kml`);
    }
    downloadJSON() {
        const text = new format_1.GeoJSON().writeFeatures(this.mapFeatures, {
            featureProjection: this.projection.featureProjection,
            dataProjection: this.projection.dataProjection,
        });
        this.downloadFile(text, `${this.parcelName}.json`);
    }
    downloadKMZ() {
        const kmlFormat = new format_1.KML();
        const kmz = new jszip_1.default();
        const kmlText = kmlFormat.writeFeatures(this.mapFeatures, {
            featureProjection: this.projection.featureProjection,
            dataProjection: this.projection.dataProjection,
        });
        kmz.file(`${this.parcelName}.kml`, kmlText);
        kmz.generateAsync({ type: 'blob' }).then((content) => {
            this.downloadFile(content, `${this.parcelName}.kmz`);
        });
    }
    downloadFile(data, filename) {
        const blob = new Blob([data], { type: 'text/plain' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
    }
}
exports.default = Download;
